const Post = ({title, imageURL, date, categories, excerpt, link, author, updateFilter}) => {

    const handleCategoryClick = (event) => {
        event.preventDefault()
        updateFilter('blog-filters__category', event.target.getAttribute('data-category'))
    }

    const postImage = () => {
        if (typeof imageURL !== undefined && imageURL !== null) {
            return (typeof link !== 'undefined' && link !== null)
                ? (
                    <a className="image-link" href={link} aria-label="blog-tease-article">
                        <img class="featured-post-image" src={imageURL} alt="blog-tease-article-image"/>
                    </a>
                )
                : <img className="featured-post-image" src={imageURL}/>
        }
    }

    const postCategories = () => {
        return categories
            ? categories.map((category) => {
                if (typeof category?.name !== 'undefined') {
                    return (
                        <>
                            <span className="category badge" onClick={handleCategoryClick} data-category={category.id}>{category.name}</span>
                        </>
                    )
                }
            })
            : <></>
    }

    const style = {
        "--ts_bg": "url(" + imageURL + ")"
    }

    return (
        <div className="tease-case-study grid rounded-corners__large" style={style}>
            <div className="background-card rounded-corners__large">
                <div className="h3">{title}</div>
                <a href={link} className="button button-secondary">Read case study</a>
            </div>
        </div>
    )
}

export default Post